import React from 'react'

const HeaderCursorIcon = () => {
    return (
        <div>
            <h1 className='mt-[100px] text-5xl text-orange-500 font-semibold'>Credit Page</h1>
            <h2 className='text-3xl mt-2'>For my cursors i have used icon from <a className='text-orange-500 font-semibold' href="https://icons8.it/">Icon8</a></h2>
            <h3>I use this page to give credits and thanks to Icon8</h3>
        </div>
    )
}

export default HeaderCursorIcon
